import { PureComponent } from 'react';

import Link from 'Component/Link';
import isMobile from 'Util/Mobile';

import './PromotionHero.style';

class PromotionHero extends PureComponent {

    renderHeroList() {
        const {
            title,
            subtitle,
            button_text,
            slug,
            banner_url,
            background_color,
            background_image,
            background_image_mobile_featured,
            text_color,
            show_text_featured
        } = this.props;

        const url = banner_url ? banner_url : `/promo/${slug}`;
        const selectedBackgroundImage = isMobile.any() ? background_image_mobile_featured : background_image;

        return (
            <Link
                to={url}
                block="PromoHero"
                style={{
                    backgroundColor: background_color,
                    color: text_color
                }}
            >
                <div block="PromoHero" elem="Image">
                    <img src={selectedBackgroundImage} />
                </div>
                {show_text_featured && (
                    <div block="PromoHero" elem="Content">
                        <h2 block="PromoHero" elem="Title">{title}</h2>
                        <h3 block="PromoHero" elem="Subtitle">{subtitle}</h3>
                        <span block="PromoHero" elem="Button">{button_text}</span>
                    </div>
                )}
            </Link>
        );
    }

    renderHeroView() {
        const {
            title,
            subtitle,
            button_text,
            slug,
            button_url,
            background_color,
            background_image,
            background_image_mobile,
            text_color,
            show_text
        } = this.props;

        const selectedBackgroundImage = isMobile.any() ? background_image_mobile : background_image;

        if (button_url) {
            return (
                <Link
                    to={button_url}
                    block="PromoHero"
                    style={{
                        backgroundColor: background_color,
                        color: text_color
                    }}
                >
                    <div block="PromoHero" elem="Image">
                        <img src={selectedBackgroundImage} />
                    </div>
                    {show_text && (
                        <div block="PromoHero" elem="Content">
                            <h2 block="PromoHero" elem="Title">{title}</h2>
                            <h3 block="PromoHero" elem="Subtitle">{subtitle}</h3>
                            <span block="PromoHero" elem="Button">{button_text}</span>
                        </div>
                    )}
                </Link>
            );
        }

        return (
            <div
                block="PromoHero"
                style={{
                    backgroundColor: background_color,
                    color: text_color
                }}
            >
                <div block="PromoHero" elem="Image">
                    <img src={selectedBackgroundImage} />
                </div>
                {show_text && (
                    <div block="PromoHero" elem="Content">
                        <h2 block="PromoHero" elem="Title">{title}</h2>
                        <h3 block="PromoHero" elem="Subtitle">{subtitle}</h3>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { renderType } = this.props;

        if (renderType === 'list') {
            return this.renderHeroList();
        }

        if (renderType === 'view') {
            return this.renderHeroView();
        }

        return null;
    }
}

export default PromotionHero;
